import { Component } from '@angular/core';
import { Footer } from '../../core/shell/footer/footer';

interface BlogImage {
    id: number;
    url: string;
    title: string;
    date: string;
}

@Component({
    selector: 'page-events',
    imports: [
        Footer
    ],
    templateUrl: './events-page.component.html'
})
export class EventsPageComponent {

    blogImages: BlogImage[] = [
        {
            id: 1,
            url: '/assets/images/events/Netwerkdag-oss.jpeg',
            title: 'Infrahub B.V. (Oss)',
            date: '18 Januari 2025'
        },
        {
            id: 2,
            url: '/assets/images/events/tempel1.jpg',
            title: 'Jaap Tempel B.V. (Groningen)',
            date: '14 Maart 2024'
        },
        {
            id: 3,
            url: '/assets/images/events/hof2.jpeg',
            title: 'Van ’t Hof B.V. (Spijkenisse)',
            date: '26 september 2024'
        },
        {
            id: 4,
            url: '/assets/images/events/ziel1.jpg',
            title: 'Van der Ziel B.V. (Biddinghuizen)',
            date: '28 November 2024'
        },
    ];

}
